import ItemCard from "./ItemCard";

export default function ItemGrid({ items, emptyMessage, emptyClassName = "empty" }) {
  return (
    <section className="grid" id="grid">
      {items.length ? items.map((item) => <ItemCard key={item.id} item={item} />) : <div className={emptyClassName}>{emptyMessage}</div>}
    </section>
  );
}
